import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const CUSTOM_INTEGRATION_ACTIVATION_MODAL_ID =
  'enable-custom-integration-modal';

export const CUSTOM_INTEGRATION_ACTIVATION_FIELDS = {
  [IntegrationEnum.TINYPNG]: [
    {
      name: 'apiKey',
      fieldType: 'text',
    },
  ],
  [IntegrationEnum.HELLOSIGN]: [
    {
      name: 'apiKey',
      fieldType: 'text',
    },
  ],
  [IntegrationEnum.MAILCHIMP]: [
    {
      name: 'apiKey',
      fieldType: 'text',
    },
    {
      name: 'audienceId',
      fieldType: 'text',
    },
  ],
  [IntegrationEnum.POINTCENTRAL]: [
    {
      name: 'login',
      fieldType: 'text',
    },
    {
      name: 'password',
      fieldType: 'password',
    },
  ],
  [IntegrationEnum.VACATIONRENTPAYMENT]: [
    {
      name: 'login',
      fieldType: 'text',
    },
    {
      name: 'password',
      fieldType: 'password',
    },
    {
      name: 'propertyCode',
      fieldType: 'text',
    },
  ],
};
